<!-- 抖音的达人历史合作明细   -->
<!-- 通过src/pages/daren/Cooperation/Cooperation2.vue 间接的被快手、b站详情页使用 -->
<!-- 通过src/pages/rednote/components/CooperationCases.vue 间接的被小红书详情页使用 -->
<template>
    <div class="wrap" v-loading="loading">
        <div v-if="msg && icon" class="tips">
            <img class="icon" :src="iconMap[icon]">
            <span class="msg">{{ msg }}</span>
            <span v-if="icon == 'dissatisfied'" class="primary" @click="onDissatisfiedSearch">了解一下</span>
        </div>
        <div class="search-wrap">
            <el-form ref="searchForm" :inline="true" label-width="76px" :model="searchForm" size="small">

                    <el-form-item label="下单日期" class="date-picker" prop="adddt_ext">
                        <el-date-picker v-model="searchForm.adddt_ext" type="daterange" range-separator="-"
                            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
                            style="width: 230px" clearable>
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="订单单号" prop="order_num">
                        <el-input v-model="searchForm.order_num"  ></el-input>
                    </el-form-item>
                    <el-form-item label="营销标的" prop="product">
                        <el-input v-model="searchForm.product"  ></el-input>
                    </el-form-item>
                    <template v-if="isSearchExpand">
                        <el-form-item label="内容质量" prop="quality">
                            <el-select v-model="searchForm.quality" placeholder="请选择" clearable>
                                <el-option v-for="item in selectOptions.type1" :key="item.value" :label="item.label"
                                    :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="合作体验" prop="experience">
                            <el-select v-model="searchForm.experience" placeholder="请选择" clearable>
                                <el-option v-for="item in selectOptions.type1" :key="item.value" :label="item.label"
                                    :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="数据效果" prop="effect">
                            <el-select v-model="searchForm.effect" placeholder="请选择" clearable>
                                <el-option v-for="item in selectOptions.type1" :key="item.value" :label="item.label"
                                    :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="合作形式" prop="jointype">
                            <el-select v-model="searchForm.jointype" placeholder="请选择" clearable>
                                <el-option v-for="item in selectOptions.jointype" :key="item.value" :label="item.label"
                                    :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item v-if="plat !== '小红书'" label="产品" prop="order_type">
                            <el-select v-model="searchForm.order_type" placeholder="请选择" clearable>
                                <el-option v-for="item in searchOptionsObj.order_type" :key="item.value"
                                    :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </template>
                    <el-form-item>
                        <el-button type="primary" @click="onSearch">搜索</el-button>
                        <el-button @click="onReset">重置</el-button>
                        <el-button type="primary" @click="() => isSearchExpand = !isSearchExpand">{{ isSearchExpand ?
                            '简略搜索' : '高级搜索' }}
                        </el-button>
                    </el-form-item>
            </el-form>
        </div>
        <vxe-grid ref="xGrid" v-bind="gridOptions" :columns="columns">
            <template #operation_column="scoped">
                <vxe-button @click="listItemClick(scoped.row)">
                    营销数据
                </vxe-button>
            </template>
        </vxe-grid>

        <vxe-modal v-model="marketingDataModal.show" title="营销数据" width="1260" height="630">
            <template #default>
                <div class="marketingDataModalWrap">
                    <div class="border-card">
                        <div class="part-top-bar">
                            <div class="title">
                                执行效果基本信息
                            </div>
                            <div class="right">

                            </div>
                        </div>
                        <div class="card-content">
                            <div class="form-wrap">
                                <div class="form-item" v-for="(item, i) in marketingDataModal.formList" :key="i">
                                    <span class="label">{{ item.label }}:</span>
                                    <span class="value">{{ item.value }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="border-card">
                        <div class="part-top-bar">
                            <div class="title">
                                本次合作执行效果
                            </div>
                            <div class="right">

                            </div>
                        </div>
                        <div class="card-content">
                            <div class="panel-list">
                                <div class="panel-item" v-for="(item, i) in marketingDataModal.panelArr" :key="i">
                                    <div class="panel-top-bar">
                                        <el-tooltip v-if="item.titleTip" effect="dark" :content="item.titleTip"
                                            placement="top">
                                            <i class="vxe-icon-question-circle-fill"></i>
                                        </el-tooltip>
                                        <span>{{ item.title }}</span>
                                    </div>
                                    <div class="panel-content">
                                        <span class="value">{{ item.content }}</span>
                                    </div>
                                    <div class="panel-bottom-bar" v-if="item.bottomTip">
                                        {{ item.bottomTip }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="border-card">
                        <div class="part-top-bar">
                            <div class="title">
                                合作评价
                            </div>
                            <div class="right">

                            </div>
                        </div>
                        <template v-if="evaluationBoxConfig">
                            <EvaluationBox :config="evaluationBoxConfig" />
                        </template>
                        <template v-else>
                            <div class="card-content">
                                <div class="tags">
                                    <div class="tagItem" v-for="(item, i) in marketingDataModal.getDrDetail" :key="i">
                                        <span>{{ item.label }}：</span>
                                        <img :src="iconMap[item.resultIcon]" alt="" />
                                        <span class="y">{{ item.resultText }}</span>
                                    </div>
                                </div>
                                <div class="comment"><span class="label">评价内容：</span>{{ marketingDataModal.commentText
                                    ||
                                    '无' }}</div>
                            </div>
                        </template>
                    </div>
                </div>
            </template>
        </vxe-modal>

    </div>
</template>
<script>


export default {
    props: {
        fieldsOptions: {
            type: Object,
            default: null
        },
        plat: {
            type: String,
        },
        shortId: {
            type: String,
        },
        viewType:{
            type:String,
            default:"短视频主页"
        }
    },
    components:{
        EvaluationBox: ()=>import('@/pages/daren/Cooperation/EvaluationBox.vue'), //新版评价展示
    },
    data() {
        return {
            loading: false,
            isSearchExpand: false,
            searchForm: {
                adddt_ext: [],
                order_num: '',
                product: '',
                quality: '',
                experience: '',
                effect: '',
                jointype: '',
                order_type: this.plat == '小红书' ? '小红书/微博' : this.viewType == '直播主页' ? '一口价直播' : "",
            },
            iconMap: {
                'satisfied': require('@/assets/images/satisfied.png'), //满意
                'very_satisfied': require('@/assets/images/very_satisfied.png'), //非常满意
                'dissatisfied': require('@/assets/images/dissatisfied.png'),  //不满意
                '合作评价_不满意': require('@/pages/detail/images/comment1.png'),  // 合作评价
                '合作评价_满意': require('@/pages/detail/images/comment2.png'),  //
                '合作评价_很满意': require('@/pages/detail/images/comment3.png'),  //
            },
            icon: '',
            msg: '',
            searchOptionsObj: {},
            selectOptions: {
                type1: [
                    { label: "很满意", value: "100" },
                    { label: "满意", value: "70" },
                    { label: "不满意", value: "50" },
                ],
                jointype: [
                    { label: '我们下单', value: '我们下单' },
                    { label: '客户下单', value: '客户下单' },
                    { label: '不走平台', value: '不走平台' },
                    { label: '其他模式', value: '其他模式' },
                ]
            },
            curSort: {},
            gridOptions: {
                id: 'cooperationDetailTable-grid-1',
                border: 'inner',
                showOverflow: true,
                sortConfig: {
                    trigger: 'cell',
                    remote: true,
                    defaultSort:{
                        field: 'log_time',
                        order: 'desc'
                    }
                },
                pagerConfig: {
                    pageSize: 10,
                    pageSizes: [10, 30, 50, 100]
                },
                proxyConfig: {
                    seq: true, // 启用动态序号代理
                    sort: true, // 启用排序代理
                    // filter: true, // 启用筛选代理
                    props: {
                        result: 'rows', // 配置响应结果列表字段
                        total: 'totalCount' // 配置响应结果总页数字段
                    },
                    ajax: {
                        // 接收 Promise 对象
                        query: async ({ page, sorts, code }) => {
                            console.log('sorts :>> ', sorts);
                            console.log('this.searchForm :>> ', this.searchForm);
                            if(this.searchForm?.order_type){
                                localStorage.setItem('order_type',this.searchForm?.order_type)
                            }
                            const params = {
                                ...this.searchForm,
                                plat: this.plat,
                                shortid: this.shortId,
                                is_live: this.viewType == '直播主页' ? 1 : 0,
                                version: 2
                            }
                            params.adddt_ext_start = this.searchForm?.adddt_ext?.[0] || ""
                            params.adddt_ext_end = this.searchForm?.adddt_ext?.[1] ? `${this.searchForm?.adddt_ext?.[1]} 23:59:59` : ""
                            delete params.adddt_ext

                            // 重置时保留排序
                            if(code == 'reload') {
                                sorts = this.curSort
                                this.$refs.xGrid.sort(this.curSort)
                            }else {
                                this.curSort = sorts
                            }

                            // 处理排序条件
                            const firstSort = sorts[0]
                            if (firstSort) {
                                params.orderfield = firstSort.field
                                params.sort = firstSort.order
                            }

                            params.page = page.pageSize !== this.gridOptions.pagerConfig.pageSize ? 1 : page.currentPage
                            if(params.page === 1){
                                const { pager } = this.$refs.xGrid.getProxyInfo()
                                pager.currentPage = 1
                            }
                            params.limit = page.pageSize
                            this.gridOptions.pagerConfig.pageSize = page.pageSize
                            this.loading = true
                            const res = await this.$axios.post('/api.php?m=case|api|gx&a=drCaseListV3', params, { headers: { showLoading: false } })
                            this.loading = false
                            this.$emit('datachange', res)
                            let { rows = [], totalCount = 0, msg, level } = res || {}
                            this.msg = msg || ''
                            switch (level) {
                                case 1:
                                    // 不满意
                                    this.icon = 'dissatisfied'
                                    break;
                                case 2:
                                    // 满意
                                    this.icon = 'satisfied'
                                    break;
                                case 3:
                                    // 很满意
                                    this.icon = 'very_satisfied'
                                    break;
                                default:
                                    break;
                            }

                            return {
                                rows,
                                totalCount
                            }
                        },

                    }
                },
                toolbarConfig:{
                    custom: true
                },
                customConfig:{
                    storage: {
                        visible: true,
                        resizable: true,
                    }
                }
            },
            marketingDataModal: {
                show: false,
                panelArr: [],
                formList: [],
                getDrDetail: [],
                commentText: ''
            },
            evaluationBoxConfig: null
        }
    },
    methods: {
        onDissatisfiedSearch(){
            this.$refs.searchForm.resetFields()
            const now = this.dayjs();
            // 计算近 180 天的开始时间
            const startDate = now.subtract(180, 'day');
            // 计算近 180 天的结束时间
            const endDate = now;
            this.searchForm.adddt_ext = [
                startDate.format('YYYY-MM-DD'),
                endDate.format('YYYY-MM-DD 23:59:59')
            ]
            this.searchForm.quality = '50'
            this.searchForm.experience = '50'
            this.searchForm.effect = '50'
            this.$refs.xGrid.commitProxy('reload')
        },
        onSearch() {
            this.$refs.xGrid.commitProxy('query')
        },
        onReset() {
            this.$refs.searchForm.resetFields()
            this.$refs.xGrid.commitProxy('reload')

        },
        getOptionsData() {
            this.$axios.post('/api.php?m=case|api|gx&a=searchList', {
                is_live: this.viewType == '直播主页' ? 1 : 0
            }, { headers: { showLoading: false } }).then(res => {
                if (this.viewType == '直播主页') {
                    res.order_type = res.order_type.filter(item=>['一口价直播','一口价直播（框架资源包）','直播-CPA'].includes(item.label))
                }
                this.searchOptionsObj = res

            }).catch(err => {} )
        },
        listItemClick(row) { //点击跳转
            const { nid, type, origid } = row
            let inSalesGroup = window.sessionStorage.getItem('inSalesGroup')
            let name = window.sessionStorage.getItem('name')
            window.sessionStorage.clear()
            window.sessionStorage.setItem('inSalesGroup', inSalesGroup)
            window.sessionStorage.setItem('name', name)
            let routeData
            if (this.plat == '小红书') {
                this.marketingDataModalShow(row)
                return
            }
            if (row.starid && row.account_number == "我们下单") {
                if (type === "一口价直播") {
                    if (this.plat == "抖音") {
                        routeData = this.$router.resolve({
                            // path: '/drliveDetail',
                            path: '/liveBroadcastDetail',
                            query: { id: nid, origid }
                        })
                    }
                    else if (this.plat == "快手") {
                        routeData = this.$router.resolve({
                            path: '/ksliveBroadcastDetail',
                            query: { id: nid, origid }
                        })
                    }
                } else {
                    if (this.plat == "抖音") {
                        routeData = this.$router.resolve({
                            // path: '/cooperationDetail',
                            path: '/shortVideoDetail',
                            query: { id: nid, origid }
                        })
                    } else if (this.plat == "快手") {
                        routeData = this.$router.resolve({
                            // path: '/cooperationDetail',
                            path: '/ksShortVideoDetail',
                            query: { id: nid, origid }
                        })
                    }
                }
            } else {
                routeData = this.$router.resolve({
                    path: '/cooperationDetail',
                    query: {
                        id: origid,
                        mid: row.order_id, //新评价需要用的
                        origid: row.origid //新评价需要用的
                    }
                })
            }

            window.open(routeData.href, "_blank");

            // 合作明细 营销数据跳转埋点
            let logParams = {
                type: 6,
                plat: this.plat == "抖音" ? 1 : this.plat == "快手" ? 2 : this.plat == "B站" ? 3 : this.plat == "小红书" ? 4 : null,//和文俊确认一下
                starid: this.$route.query.id || '',
                shortid: this.$route.query.shortid || '',
                tags: [{ field: "origid", value: origid }]
            }
            this.$api.setUseLog(logParams)
        },
        // 营销数据弹窗
        async marketingDataModalShow(data) {
            const params = {
                mid: data.order_id,
                origid: data.origid
            }
            const res = await this.$axios.get('/api.php?m=case|api|gx&a=cooperationDetail', { params, headers: { showLoading: false } })
            const { base_info = {}, execution = {} } = res
            if(base_info.evaluation_json){
                this.evaluationBoxConfig = JSON.parse(base_info.evaluation_json)
            }

            this.marketingDataModal.formList = [
                {
                    label: '订单号',
                    value: base_info.order_num
                },
                {
                    label: '执行媒介',
                    value: base_info.meijie_name
                },
                {
                    label: '发布时间',
                    value: execution.release_at
                },
                {
                    label: '笔记标题',
                    value: execution.title
                },
            ]
            this.marketingDataModal.panelArr = [
                {
                    title: '曝光量',
                    titleTip: '',
                    content: execution.baoguang?.toLocaleString(),
                    bottomTip: ''
                },
                {
                    title: '阅读量',
                    titleTip: '',
                    content: execution.playnum?.toLocaleString(),
                    bottomTip: ''
                },
                {
                    title: '点赞量',
                    titleTip: '',
                    content: execution.likenum?.toLocaleString(),
                    bottomTip: ''
                },
                {
                    title: '收藏量',
                    titleTip: '',
                    content: execution.collectnum?.toLocaleString(),
                    bottomTip: ''
                },
                {
                    title: '评论量',
                    titleTip: '',
                    content: execution.commentnum?.toLocaleString(),
                    bottomTip: ''
                },
                {
                    title: '分享量',
                    titleTip: '',
                    content: execution.forwardnum?.toLocaleString(),
                    bottomTip: ''
                },
                {
                    title: '关注量',
                    titleTip: '',
                    content: execution.follow?.toLocaleString(),
                    bottomTip: ''
                },
                {
                    title: '互动量',
                    titleTip: '',
                    content: execution.hudong?.toLocaleString(),
                    bottomTip: ''
                },
                {
                    title: 'CPE',
                    titleTip: '',
                    content: execution.cpe?.toLocaleString(),
                    bottomTip: ''
                },
                {
                    title: 'CPV',
                    titleTip: '',
                    content: execution.cpv?.toLocaleString(),
                    bottomTip: ''
                },
                {
                    title: 'CPM曝光',
                    titleTip: '',
                    content: execution.cpm_baoguang?.toLocaleString(),
                    bottomTip: ''
                },
                {
                    title: 'CPM阅读',
                    titleTip: '',
                    content: execution.cpm?.toLocaleString(),
                    bottomTip: ''
                },
            ]
            const feedbackMap = {
                100: '很满意',
                70: '满意',
                50: '不满意'
            }
            this.marketingDataModal.getDrDetail = [
                {
                    label: '内容质量', //quality
                    resultIcon: `合作评价_${feedbackMap[+base_info.quality]}`,
                    resultText: feedbackMap[+base_info.quality]
                },
                {
                    label: '合作体验', // experience
                    resultIcon: `合作评价_${feedbackMap[+base_info.experience]}`,
                    resultText: feedbackMap[+base_info.experience]
                },
                {
                    label: '数据效果', //effect
                    resultIcon: `合作评价_${feedbackMap[+base_info.effect]}`,
                    resultText: feedbackMap[+base_info.effect]
                },
            ]
            this.marketingDataModal.commentText = base_info.evaluation || ''
            this.marketingDataModal.show = true
        }
    },
    computed: {
        columns() {
            const fields = this.searchOptionsObj.detail_field || []
            //   { field: 'nickname', title: 'Nickname', sortable: true, minWidth: 160 },
            let columns = fields.map(item => {
                return {
                    field: item.fields, title: item.name, sortable: item.ispx == 1, minWidth: 160
                }
            })
            // console.log('columns :>> ', columns);
            // let filterTitle = []
            // switch (this.searchForm.order_type) {
            //     case '一口价直播':
            //     case '一口价直播（框架资源包）':
            //     case '直播-CPA':
            //     filterTitle = '营销标的,游戏类型,产品类型,下单时间,合同价格,达人报价,利润率%,补款达人金额,合作账号昵称,账号ID,账号UID,合作平台,添加达人时间,资产方,客户名称,订单号,订单原id,询单媒介,执行媒介,合作供应商,合作形式,评分'.split(',')
            //         break
            //     case '短视频生态':
            //     filterTitle = '营销标的,产品类型,下单时间,实际支付成本税后,集团流水,集团毛利,合作账号昵称,账号ID,账号UID,平台,总发文数,总播放量,总点赞数,总评论数,总收藏数,总分享数,执行周期,订单号,执行媒介'.split(',')
            //         break
            //     case '直播生态':
            //     filterTitle = '营销标的,产品类型,下单时间,总支出（税后）,集团流水,集团毛利,合作账号昵称,账号ID,账号UID,平台,近期直播场次,平均观看人数,平均观看人次,ACU,PCU,粉丝观看占比,场均涨粉数,平均评论率%,场均点赞率%,平均观看时长,执行周期,订单号,执行媒介'.split(',')
            //         break
            //     case '短视频资源包':
            //         filterTitle = '营销标的,下单时间,结算金额,达人报价,利润率%,达人自然返点率%,返点比例,返点金额,订单号,询单媒介,执行媒介,合作形式,保量条款,内容质量,合作体验,数据效果'.split(',')
            //         break
            //     default:
            //     filterTitle = '订单号,产品类型,营销标的,询单媒介,执行媒介,记录时间,结算金额,达人报价,税后集团利润,合作形式,达人自然返点率%,下单价格,补款达人金额,返点金额,机构/达人退款金额,税后合同价格,供应商,项目类型,客户名称,利润率%,返点比例,保量条款,内容质量,合作体验,数据效果'.split(',')
            // }

            let filterFields = [
                "score",//综合评分
                "order_num",//订单单号
                "order_type",//产品名
                "product",//营销标的
                "opname",//运营
                "log_time",//记录时间
                "contract_price",//合同价格
                "talent_price",//达人报价
                "at_group_profit",//税后集团利润
                "mt_profit",//达人自然返点率%
                "bl_cont",//保量条款
                "self_maintenance", //达人自行维护
                "jointype",//合作形式
                "official_settlement",//官方结算量
                "settlement_rule",//达人结算规则
                "capped_amount",//封顶金额
                "group_sum_amount",//集团流水
                "order_price",//下单价格
                "talent_bu_amount",//补款达人金额
                "rebate_amount",//返点金额
                "talent_tui_amount",//机构/达人退款金额
                "cust_check_status",//客户验收情况
                "at_contractprice",//税后合同价格
                "out_amount",//打款金额
                "talen_amount_sum",//达人流水
                "supplier_name",//供应商
                "project_type",//项目类型
                "cust_name",//客户名称

                "take_type",//投放类型
                "rebate_rate",//返点比例
                "profit_rate",//利润率
                "final_gmv",//最终GMV
                "arc_num",//发文量
                "valid_days",//有效天数
                "valid_times",//有效时长
                "talent_base_salary",//达人基础薪资
            ]

            let sortedColumns = []
            filterFields.forEach((field)=>{
                const col = columns.find(item=> item.field == field)
                if (col) {
                    if(col.field == 'score'){
                        col.formatter= ({cellValue})=>{
                            if(cellValue == 5){
                                return '满意'
                            } else if(cellValue == 1){
                                return '不满意'
                            } else {
                                return cellValue
                            }

                        }
                    }
                    sortedColumns.push(col)
                }
            })
            sortedColumns.push(
                { width: 120, title: '操作', fixed: 'right', slots: { default: 'operation_column' } }
            )
            return sortedColumns
        }
    },
    mounted() {
        if (this.fieldsOptions) {
            this.searchOptionsObj = this.fieldsOptions
        } else {
            this.getOptionsData()
        }
    },
};
</script>
<style lang='scss' scoped>
.wrap{
    width: 100%;
}
.tips{
    font-family: "苹方 常规体", 苹方, sans-serif;
    font-weight: 400;
    font-style: normal;
    color: #4e5969;
    font-size: 14px;
    margin: 20px 0;
    line-height: 1.5;
    .icon {
        width: 16px;
        height: 16px;
        margin-right: 10px;
        vertical-align: middle;
    }
    .primary{
        cursor: pointer;
        color: #ff6f28;

    }
}

.part-top-bar {
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    .title {
        display: flex;
        align-items: center;

        &::before {
            content: '';
            display: inline-block;
            width: 8px;
            height: 1.5em;
            margin-right: 6px;
            background-color: #ff6f28;
            border-radius: 4px;
        }

        .el-tooltip {
            margin-left: 10px;
            font-size: 14px;
        }
    }

    .right {
        margin-left: auto;
        margin-right: 0;
        font-size: 14px;

        &>* {
            margin-left: 10px;
        }
    }
}

.border-card+.border-card {
    margin-top: 20px;
}

.border-card {
    border-radius: 8px;
    border: 1px solid #f2f3f5;
    padding: 20px;
    box-sizing: border-box;

    .card-top-bar {
        display: flex;
        align-items: center;
        margin-bottom: 14px;
        height: 34px;

        .icon {
            width: 24px;
            height: 24px;
            margin-right: 10px;
        }

        .title {
            font-family: "苹方 中黑体", "苹方 常规体", 苹方, sans-serif;
            font-weight: 500;
            font-style: normal;
            font-size: 16px;
            color: rgb(29, 33, 41);
            line-height: 1.5;
            border-width: 0px;
        }

        .right {
            margin-left: auto;
            margin-right: 0;
        }
    }

    .card-content {}

}

.panel-list {
    display: flex;
    flex-flow: row wrap;
    gap: 20px;

    &>div {
        flex: 1 1 calc(100% / 7 - 120px / 7);
        max-width: calc(100% / 7 - 120px / 7);
    }

    @media (max-width: 1500px) {
        &>div {
            flex: 1 1 calc(100% / 5 - 100px / 5);
            max-width: calc(100% / 5 - 100px / 5);
        }
    }

    .panel-item {
        font-family: "苹方 常规体", 苹方, sans-serif;
        font-weight: 400;
        font-style: normal;
        font-size: 14px;
        line-height: normal;
        box-sizing: border-box;
        border-right: 1px solid #f2f3f5;

        &:last-of-type,
        &:nth-of-type(5n) {
            border-right: unset;
        }

        .panel-top-bar {
            color: #4e5969;

            .el-tooltip {
                margin-right: 8px;
            }
        }

        .panel-content {
            line-height: 2;

            .value {
                font-family: "苹方 中黑体", "苹方 常规体", 苹方, sans-serif;
                font-weight: 500;
                font-style: normal;
                font-size: 24px;
                color: #ff5c00;
            }
        }

        .panel-bottom-bar {
            color: #a9aeb8;

            .value {
                color: #000;
            }
        }
    }
}

.marketingDataModalWrap {
    .form-wrap {
        display: flex;
        align-items: center;
        box-sizing: border-box;
        flex-flow: row wrap;
        gap: 20px;

        .form-item {
            display: inline-block;
            font-family: "苹方 中黑体", "苹方 常规体", 苹方, sans-serif;
            font-weight: 500;
            font-style: normal;
            font-size: 16px;
            color: #1d2129;
            line-height: 20px;

            .label {
                color: #4e5969;
                margin-right: 20px;
            }

            &:nth-of-type(2n-1) {
                flex: 0 0 280px;
            }

            &:nth-of-type(2n) {
                flex: 0 0 calc(100% - 300px);
            }
        }

    }

    .tags {
        margin: 0 auto 20px;
        display: flex;
        align-items: center;
        justify-content: center;

        .tagItem {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-right: 20px;
            font-size: 20px;
            font-family: OPPOSans;
            font-weight: 500;
            color: #666666;
            line-height: 36px;

            .y {
                color: #ff5c00;
            }

            img {
                display: inline-block;
                width: 36px;
                height: 36px;
                margin: 0 8px 0 16px;
            }
        }
    }

    .comment {
        background: #f2f3f5;
        border-radius: 8px 8px 0px 0px;
        padding: 10px 20px;
        box-sizing: border-box;
        font-family: "苹方 常规体", 苹方, sans-serif;
        font-weight: 400;
        font-style: normal;
        line-height: 20px;
        font-size: 14px;
        color: #333333;

        .label {
            color: #4e5969;
        }
    }
}
</style>